module.exports = __webpack_public_path__ + "static/media/zoom_out.d32786a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/zoom_out.svg
// module id = 858
// module chunks = 0